











import { Component, Prop, Vue } from 'vue-property-decorator'
import { Item } from '@/interfaces/item'

@Component
export default class DeleteAction extends Vue {
  @Prop(String)
  readonly text?: string

  @Prop(String)
  readonly path!: string

  @Prop(Object)
  readonly item!: Item

  async remove() {
    const { id } = this.item!
    await this.$api.delete(`${this.path}/${id}`)

    this.$emit('removed')
    await this.$message.success(`Удалено`)
  }
}
